export enum FeatureGroupEnum {
	REAL_ESTATE = 'REAL_ESTATE',
	ASSISTANTS = 'ASSISTANTS',
	REFER_A_FRIEND = 'REFER_A_FRIEND',
	MARKET_PRICING_ASSISTANT = 'MARKET_PRICING_ASSISTANT'
}
